import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authActions from "../../Redux/auth/actions";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import examActions from "../../Redux/exam/actions";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  TableContainer,
} from "@mui/material";
import usePreventBackNavigation from "../../hooks/usePreventBackNavigation";
import PreventBackNavigationWarningModal from "../../components/liveTest/preventBackNavigationWarningModal";
import Cookies from "js-cookie";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import { handleEncodeJson, handleDecodeJSON } from "../../utils/encodeDecodeJson";
import InitYoloScreen from "../InitYoloScreen";

const Index = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const exams = useSelector(
    (state) => state.examReducer.examSchedule
  );
  const [disabledExamId, setDisabledExamId] = useState(null);
  const [showBackWarning, setShowBackWarning] = useState(false);
  const [inityoloModel, setInityoloModel] = useState(false);
  const [title,setTitle] = useState('')
  const [info,setInfo] = useState('')
  usePreventBackNavigation(setShowBackWarning);

 function initExamPlatform() {
  setInityoloModel(true);
  setTitle("Initializing Exam Platform");
  setInfo("If it's taking too long, please ensure your internet connection is stable.");

  axios.get('/angular-components/angular-app/assets/models/yolo11s.onnx', {
    responseType: 'arraybuffer'
  })
    .then((res) => {
      setInityoloModel(false);
    })
    .catch((err) => {
      setInityoloModel(true);
      setTitle("Failed to Initialize Exam Platform");
      setInfo("Check your internet connection.");
      console.log(err);
    });
}

  const handleStartExam = (exam) => {
    setDisabledExamId(exam.projectMasterId);
    sessionStorage.setItem("activeExam", JSON.stringify(exam));
    dispatch({
      type: authActions.CANDIDATE_LOGIN,
      payload: {
        data: {
          // identitynumber: localStorage.getItem("userName"),
          // password: localStorage.getItem("password"),
          projectMasterId: exam.projectMasterId
        },
        navigate,
        mockMode: false
      }
    });
  };

  const handleUpload = async (exam) => {
    try {
      const encodeData = await handleEncodeJson({
        encodeJSON: { projectMasterId: exam.projectMasterId },
      });
      const result = await axios.post(
        `${API_URL}/api/exam/descriptive-upload/post-exam/token-validator`,
        encodeData
      );
      const decoded = await handleDecodeJSON({ decodeJSON: result?.data?.data });
      const project = Cookies.get("test_engine_project");
      navigate(`/${project}/post-exam-upload?${decoded?.token}`);
    } catch {
      navigate("/thank-you");
    }
  };

  useEffect(() => {
    if(process.env.REACT_APP_YOLO_LOADER === 'true') {
      initExamPlatform()
    }
    dispatch({ type: examActions.GET_EXAM_SCHEDULE })
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval)
  }, [])

  if (inityoloModel) {
    return (
      <InitYoloScreen
        title={title}
        info={info}
        showLoader={true}
      />
    );
  }
  const renderButtons = (exam) => {
    const state = exam.btnState || 'START';
    if (state === "UPLOAD") {
      return (
        <>
          <Button
            variant="contained"
            onClick={() => handleUpload(exam)}
          >
            {state}
          </Button>
        </>
      )
    }
    else if (state === "SUBMITTED") {
      return (
        <Button
          variant="contained"
          disabled={true}
        >
          {state}
        </Button>
      )
    }
    else {
      return (
        <Button
          variant="contained"
          onClick={() => handleStartExam(exam)}
          disabled={state === "UPCOMING" ? true : false}
        >
          START EXAM
        </Button>
      )
    }
  }



  return (
    <>
      <Box className="g-page">
        {/* PAGE CONTENT */}
        <Box className="g-content">
          <Typography className="g-title-primary">
            Exam Schedule
          </Typography>
          <Paper className="g-card">
            <TableContainer sx={{ maxHeight: "70vh" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow className="g-table-head">
                    <TableCell>Exam Name</TableCell>
                    <TableCell>Exam Date</TableCell>
                    <TableCell>Login Time</TableCell>
                    <TableCell>Start Time</TableCell>
                    <TableCell>Duration</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!exams?.length ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No exams available
                      </TableCell>
                    </TableRow>
                  ) : (
                    exams.map((exam) => {
                      const isDisabled = exam.isExamClosed === true || disabledExamId === exam.projectMasterId;
                      const buttonText = exam.candidateExamEndTime === null ? "Start Exam" : "Submitted";
                      return (
                        <TableRow key={exam.projectMasterId}>
                          <TableCell>{exam.courseName}</TableCell>
                          <TableCell>{exam.examStartDate}</TableCell>
                          <TableCell>{exam.earlyExamStartTime}</TableCell>
                          <TableCell>{exam.examStartTime}</TableCell>
                          <TableCell>{exam.timeDuration}</TableCell>
                          <TableCell align="center">
                            {renderButtons(exam)}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>
      <PreventBackNavigationWarningModal
        showBackWarning={showBackWarning}
        setShowBackWarning={setShowBackWarning}
      />
    </>
  );
};

export default Index;
